var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1176,
    height: 444,
    viewBox: "0 0 1176 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 1176,
    height: 444,
    rx: 16,
    fill: "#5356FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    clipPath: "url(#clip0_15_8078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14286e-05 0.000126275L5.79046e-05 315.647C45.5257 339.479 90.6934 357.889 134.429 351.792C270.555 332.823 290.61 109.463 427.657 56.1291C515.718 21.863 618.527 115.411 716 145.784L716 6.10352e-05L3.14286e-05 0.000126275Z",
    fill: "url(#paint0_linear_15_8078)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M2.54541e-05 0.000103229L5.7436e-05 381.288C49.2682 407.605 98.7318 425.824 148.727 424.082C352.508 416.977 409.86 109.567 619.265 54.8629C677.876 39.5516 737.618 58.3252 798 89.0167L798 3.05176e-05L2.54541e-05 0.000103229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M-3.05176e-05 444L482.83 444C486.171 423.555 487.038 403.242 484.627 383.11C462.844 201.157 209.56 157.867 110.196 3.72443e-06L-6.77597e-05 1.37651e-05L-3.05176e-05 444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_8078",
    x1: 885.687,
    y1: 9.14762,
    x2: 314.42,
    y2: 104.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2915,
    stopColor: "white",
    stopOpacity: 0.6184
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_8078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 716,
    height: 444,
    fill: "white",
    transform: "translate(716 444) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.6d70cb6226cd8f51f6f8f5ee17310ab9.svg";
export { ForwardRef as ReactComponent };